import { render, staticRenderFns } from "./IndustryNavigationList.vue?vue&type=template&id=36ac4ee2&scoped=true&"
import script from "./IndustryNavigationList.vue?vue&type=script&lang=js&"
export * from "./IndustryNavigationList.vue?vue&type=script&lang=js&"
import style0 from "./IndustryNavigationList.vue?vue&type=style&index=0&id=36ac4ee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac4ee2",
  null
  
)

export default component.exports